import { IDropdownStyles } from '@fluentui/react';

export const dropdownStyles: Partial<IDropdownStyles> = {
    root: {
        minWidth: 135 // TODO: Modify this number
    },
    title: {
        border: 'none'
    }
};
